// Strict type guard for userAgentData
const isUserAgentDataSupported = (
  navigator: Navigator
): navigator is Navigator & { userAgentData: { platform: string } } =>
  typeof (navigator as Partial<Navigator> & { userAgentData?: { platform?: unknown } })
    .userAgentData?.platform === 'string';

export const isMac = isUserAgentDataSupported(navigator)
  ? navigator.userAgentData.platform.toLowerCase().includes('mac')
  : /Mac|iPhone|iPad|iPod/.test(navigator.userAgent);
